import * as React from 'react';
import { Text } from 'ui';
import { OAuthProviderEnum } from '../../../utils/types/eunms';
import { useSSOLogin } from './useSSOLogin';
import { SSOProviderButton } from './sso-provider-button';
import { Apple } from '@components/atoms/icons/social/apple';
import { GoogleColor } from '@components/atoms/icons/social/google-color';
import { MicrosoftColor } from '@components/atoms/icons/social/microsoft-color';
import { Yahoo } from '@components/atoms/icons/social/yahoo';

type SSOActionBarProps = {
	onSuccess: () => void;
	onError?: (error: Error) => void;
};

export const SSOActionBar: React.FC<SSOActionBarProps> = ({ onSuccess, onError }) => {
	const { handleSSOLogin } = useSSOLogin({ onSuccess, onError });

	return (
		<div className="grid grid-cols-2 grid-rows-2 gap-x-[8px] gap-y-[8px] bg-transparent" data-testid="auth-sso-action-bar">
			<SSOProviderButton
				data-testid="auth-google-sso-btn"
				provider={OAuthProviderEnum.GOOGLE}
				handleSSO={handleSSOLogin}
				className="row-1 w-full columns-1"
			>
				<div className="flex items-center gap-[10px]">
					<GoogleColor width={24} height={24} />
					<Text as="p" size="md" weight="medium" className="text-black">
						Google
					</Text>
				</div>
			</SSOProviderButton>
			<SSOProviderButton
				data-testid="auth-apple-sso-btn"
				provider={OAuthProviderEnum.APPLE}
				handleSSO={handleSSOLogin}
				className="row-1 w-full columns-2"
			>
				<div className="flex items-center gap-[10px]">
					<Apple width={24} height={24} />
					<Text as="p" size="md" weight="medium" className="text-black">
						Apple
					</Text>
				</div>
			</SSOProviderButton>
			<SSOProviderButton
				data-testid="auth-microsoft-sso-btn"
				handleSSO={handleSSOLogin}
				provider={OAuthProviderEnum.MICROSOFT}
				className="row-2 w-full columns-1"
			>
				<div className="flex items-center gap-[10px]">
					<MicrosoftColor width={20} height={20} />
					<Text as="p" size="md" weight="medium" className="text-black">
						Microsoft
					</Text>
				</div>
			</SSOProviderButton>
			<SSOProviderButton
				data-testid="auth-yahoo-sso-btn"
				handleSSO={handleSSOLogin}
				provider={OAuthProviderEnum.YAHOO}
				className="row-2 w-full columns-2"
			>
				<div className="flex items-center gap-[10px]">
					<Yahoo width={24} height={24} />
					<Text as="p" size="md" weight="medium" className="text-black">
						Yahoo
					</Text>
				</div>
			</SSOProviderButton>
		</div>
	);
};
